import { CIcon } from '~/icons/types'

export const ciTractors: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M5.428 9.61a5.432 5.432 0 1 0 5.432 5.431A5.438 5.438 0 0 0 5.428 9.61Zm0 9.862a4.432 4.432 0 1 1 0-8.864 4.432 4.432 0 0 1 0 8.864Z'
    },
    {
      d:
        'M22.391 12.885c0-.009.005-.018.005-.028a3.761 3.761 0 0 0-3.763-3.763h-.24v-2.11c0-.277.085-.548.243-.775l.235-.338a.5.5 0 1 0-.822-.57l-.235.338a2.356 2.356 0 0 0-.421 1.344v2.111h-3.262L12.9 4.527h1.728a.5.5 0 0 0 0-1H3.687a.5.5 0 0 0 0 1h.787l-.788 3.59A7.3 7.3 0 0 0 .3 9.893a.5.5 0 1 0 .681.73 6.38 6.38 0 0 1 10.128 1.964A6.34 6.34 0 0 1 11.6 16.5a.501.501 0 0 0 .491.6h3.469a4.267 4.267 0 1 0 6.835-4.206l-.004-.009ZM8.906 8.833a7.321 7.321 0 0 0-4.16-.882L5.5 4.527h6.366l1.834 6.791h-2.162a7.324 7.324 0 0 0-2.632-2.485Zm3.171 3.485h2.271a.5.5 0 0 0 .483-.63l-.43-1.594h4.232a2.762 2.762 0 0 1 2.553 1.706c.058.144.103.293.135.444a4.247 4.247 0 0 0-5.85 3.847h-2.8a7.324 7.324 0 0 0-.594-3.773Zm7.654 7.155a3.271 3.271 0 1 1-.006-6.542 3.271 3.271 0 0 1 .006 6.542Z'
    },
    {
      d:
        'M5.428 13.121a1.923 1.923 0 1 0 0 3.847 1.923 1.923 0 0 0 0-3.847Zm0 2.845a.922.922 0 1 1 0-1.845.922.922 0 0 1 0 1.845ZM19.73 14.54a1.665 1.665 0 1 0 .01 3.33 1.665 1.665 0 0 0-.01-3.33Zm0 2.328a.665.665 0 1 1 .01-1.33.665.665 0 0 1-.01 1.33Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'tractors',
  type: 'thin'
}
